import { MovementDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedCard } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { toFeatured$ } from '../../serializer/featured';

@Component({
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
    },
    template: require('./movement-featured-card.html'),
})
export class MovementFeaturedCard extends ReactiveVue {
    public $movementDataStore: MovementDataStore;
    public serializer = toFeatured$;
}
